import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApachecordovaComponent } from './simple-icons-apachecordova.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApachecordovaComponent ],
    exports:      [ SimpleIconsApachecordovaComponent ],
    bootstrap:    []
})
export class SimpleIconsApachecordovaModule {}
